/* eslint-disable */

import { EventBus } from '@/event-bus.js'
import Vue from 'vue'
import { sectionService } from '../_services'

const state = {
  items: [],
  status: [],
  isLoading: false,

  dragEnabled: true,
}
const getters = {
  getItemByURL: (state) => (url) => state.items.find((item) => item.url === url),
  getStatusByURL: (state) => (url) => {
    const item = state.status.find((item) => item.url === url)

    if (!item) {
      console.log('Item status was not found')
      return 'error'
    }

    return item.status
  },
}

const actions = {
  fetchItem({ commit }, url) {
    commit('setItemStatus', {
      url,
      status: 'loading',
    })
    commit('setIsLoading', true);
    sectionService.getItemByURL(url).then((r) => {
      console.log('Sections getItemByURL', r);
      if (r) {
        commit('addItem', { png_render: '', ...r.data })
        commit('setItemStatus', {
          url,
          status: 'done',
        })
      } else {
        commit('setItemStatus', {
          url,
          status: 'error',
        })
      }
    }).catch((error) => {
      commit('setItemStatus', {
        url,
        status: 'error',
      })
    }).finally(() => { commit('setIsLoading', false); })
  },
  patchItem({ getters, commit }, url) {
    commit('setIsLoading', true);
    sectionService.patchItemByURL(url, getters.getItemByURL(url)).then((r) => {
      // console.log(r);
      // commit('replaceItem', r.data)
      EventBus.$emit('image-section:patch-result', true, r.data.id)
    }).catch((error) => {
      console.error('Could not patch section: ', error.data)
      EventBus.$emit('image-section:patch-result', false);
      EventBus.$emit('confirm', {
          message: 'There\'s been an error while trying to update, please reload this page to continue.',
          positiveText: 'Reload',
          showCancel: false,
          callback: (confirm) => {
            if (confirm) {
            // eslint-disable-next-line
            location.reload();
            }
          },
        })
    }).finally(() => { commit('setIsLoading', false); });
  },

  callReplaceItem({ getters, commit }, editSection) {
    // REMINDER: editSection must be an object containing a 'pk' prop!
    commit('replaceItem', editSection);
  }
}
const mutations = {
  reset: () => { },
  addItem(state, item) {
    state.items.push(item)
  },
  replaceItem(state, item) {
    const i = state.items.map((item) => item.pk).indexOf(item.pk)
    if (i >= 0) {
      state.items[i] = item
      Vue.set(state.items, i, item)
    } else {
      state.items.push(item)
    }
  },
  setIsLoading(state, isLoading) {
    state.isLoading = isLoading;
  },
  setItemStatus(state, { url, status }) {
    const item = state.status.find((item) => item.url === url)

    if (item) {
      item.status = status
    } else {
      state.status.push({
        url,
        status,
      })
    }
  },
  setDraggable(state, enabled) {
    state.dragEnabled = enabled
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
